import React from 'react';
import { Modal, Form,Button } from 'antd';

class EmitirModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Emitir Guía de Remisión"}
                visible={this.props.visible}
                okText={"Emitir"}
                cancelText={"Cancelar"}
                destroyOnClose={true}
                onCancel={this.props.onClose}
                onOk={() => {
                    this.props.onEmitir(this.props.form);
                }}
                style={{ top: 30 }}
                width={1200}
                footer={null}
            >
                <Form>

                <div className="row">
                        <div className="col-md-10 form-group">

                        </div>

                        <div className="col-md-1 form-group">
                            <Button type="danger" onClick={this.props.onClose}>Cancelar</Button>
                        </div>
                        <div className="col-md-1 form-group">
                            <Button type="primary" onClick={() => {
                                this.props.onEmitir(this.props.form);
                            }}>Emitir</Button>
                        </div>
                    </div>
                     <br/>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>{this.props.item?.serie} {this.props.item?.documento}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.file+ '#view=fitH'}
                                style={{ width: '100%', height: 600 }}
                                type="application/pdf"
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(EmitirModal)